import React from "react";
import { Icon } from "@bookingcom/bui-react";
import FlightDetailsAncillaryItemLayout from "../../../../../FlightDetailsAncillaryItemLayout/index.js";
import useExtraProductsInfo2Controller from "./ExtraProductsInfo2.controller.js";
import { BagHoldNotAvailableIcon } from "@bookingcom/bui-assets-react/streamline";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { track } from "@flights/et-universal";
const useExtraProductsInfo2 = (flight, baggagesExtrasOnly) => {
    const { header, baggageText } = useExtraProductsInfo2Controller(flight);
    const { isMobile, isDesktop } = useProfiler();
    if (!baggageText)
        return undefined;
    return {
        header,
        content: baggagesExtrasOnly &&
            baggageText &&
            ((isDesktop() && !!track("flights_funnel_new_fd_page_desktop")) ||
                (isMobile() && !!track("flights_funnel_new_fd_page_mobile"))) ? (React.createElement("div", { dangerouslySetInnerHTML: { __html: baggageText } })) : (React.createElement(FlightDetailsAncillaryItemLayout, { icon: React.createElement(Icon, { size: "large", svg: BagHoldNotAvailableIcon }), content: React.createElement("div", { dangerouslySetInnerHTML: { __html: baggageText } }), hideIncludedSection: true }))
    };
};
export default useExtraProductsInfo2;
